<template>
	<div :class="{'pb-30': padShow }">
		<!-- 轮播图 -->
    <swipeItem :swipeList="swipeList" height="250px" :showindicators="false" bRadius="0px"></swipeItem>

		<div class="pd-16 box-s bg_f bb-E-nr">
			<div class="flexs flex-jus mb-16">
				<div class="c6 fz-21 fw-600 l-h-21">{{data.integral}}积分</div>
			</div>

			<div class="c1 fw-500 fz-14 l-h-14 w100 text-hide">{{data.title}}</div>
		</div>

		<div class="h77 flexs pr bg_f bb-E-nr pl-16 box-s" v-if="data.type == 1">
			<div class="c1 fw-500 fz-15 mr-10">兑换码：</div>
			<input type="text" v-model="data.code" id="copy_btn1" readonly class="num_dui text-center plr-8 box-s">
			<div class="wh_96_33 text-center b-radius-6 bg_49 c7 fz-13 fw-500 l-h-33 copy_1 needsclick" data-clipboard-action="copy" data-clipboard-target="#copy_btn1" ref="copy1" @click="copy1">复制兑换码</div>
		</div>
		

		<div class="flexs bg_f bb-E-nr pd-16 box-s fw-500 c1">
			<div class="fz-15 mr-10">订单号：</div>
			<div class="fz-14">{{data.order_no}}</div>
		</div>

		<div class=" ptb-16 box-s bg_f">
       <div class="flexs mb-10 plr-16 box-s">
				 <div class="left_blue_line"></div>
				 <div class="fw-500 c1 fz-16 l-h-16 ml-8">兑换规则</div>
			 </div>

			 <div class="" v-html="data.rule"></div>
		</div>
    <div class="btn_contain">
      <div class="blue_btn" :class="{grayback: data.status == 2 }" @click="getDuiHuan">
        {{data.status == 2?'已领取':'领取'}}
      </div>
    </div>

			<!-- 二维码遮罩层 -->
		<van-overlay :show="show" @click="show = false">
			<div class=" w315 ps-50 b-radius-6 pt-55 box-s bg_shop" @click.stop>
				<img class="wh_78_80 ok_img" src="../../assets/img/icon/ok_weixin.png" alt="">
				<img class="close_icon wh_17_15" @click="show = false" src="../../assets/img/icon/close_icon.png" alt="">
				<div class="text-center pb-21">
					<div class="fz-15 fw-500 c1">请复制兑换码添加老师微信兑换</div>
					<img class="wh_126 mr-26" :src="data.teacher_ewm" alt="">
					<div class="wh_136_40 b-radius-6 c7 bg_49 fz-13 fw-500 m0-auto">长按图片保存到本地</div>
				</div>
         
				<div class="h77 flexs pr flex-center aaa">
					<div class="c1 fw-500 fz-13">兑换码：</div>
					<input type="text" v-model="data.code"  readonly class="num_dui text-center plr-8 box-s ">
					<button class="wh_65_33 text-center b-radius-6 bg_49 c7 fz-13 fw-500 l-h-33  needsclick"  type="button"
						v-clipboard:copy="data.code"
						v-clipboard:success="onCopy"
						v-clipboard:error="onError">复制</button>
				</div>
			</div>
		</van-overlay>
	</div>
</template>
<script>
  import swipeItem from '@/components/swipeItem'
  import { goodsExchangeInfo} from '@/api/api.js'
	import {getShowPadding} from "@/utils/common.js";
	import Clipboard from 'clipboard';
	export default {
		components: {
      swipeItem
		},
		data() {
			return {
        swipeList: [],
				num:'',
				data: {},
				padShow: false,
				show: false,
				pupdata: {},
				copyBtn1: '',
				copyBtn2: ''
			};
		},
		created() {
			this.initData()
		},
		mounted(){		
			this.padShow = getShowPadding()
		},
		methods: {
			onCopy(){
        this.$toast('复制成功')
			},
			onError(){
        this.$toast('该手机不支持自动复制')
			},
			// 复制
			copy1(){
        var clipboard1 = new Clipboard('.copy_1')
				console.log(clipboard1)
        clipboard1.on('success', e => {
					this.$toast('复制成功')
          // 释放内存
          clipboard1.destroy()
        })
        clipboard1.on('error', e => {
          // 不支持复制
					this.$toast('该手机不支持自动复制')
          // 释放内存
          clipboard1.destroy()
        })
			},
			async initData(){
				console.log(this.$route.query.id,'this.$route.query.id')
        const res = await goodsExchangeInfo({ id: this.$route.query.id })
				if(res.code ==  1000){
          this.data = res.data
					this.swipeList = [this.data.img]
				}else {
					 this.$toast(res.msg)
				}
			},
			async getDuiHuan(){
				if(this.data.status == 1){
					
          this.show = true
					
				}
				
			}
		}
	}
</script>
<style lang="less" scoped>
.grayback {
	background: #999999;
}
.bg_shop {
  background: url('../../assets/img/bg/jifen_bg.png') no-repeat;
  background-size: 100%;
}

.close_icon {
	position: absolute;
	top: 14px;
	right: 14px;
}
.ok_img {
  position: absolute;
	top: 0;
	left: 50%;
	transform: translate(-50%, -50%);
}

/deep/.van-overlay {
  background: rgba(0, 0, 0, 0.5);
}
</style>
